module.exports = __webpack_public_path__ + "img/column_2025special.c66a7b13.jpg";